import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  query DataUploadRequest2(
    $tenantId: ID!
    $zoneId: ID!
    $fileInput: FileInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        dataUploadRequest2(fileInput: $fileInput) {
          url
          fields {
            id
            value
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.DataUploadRequest2Query,
    ents.core.common.fileManagement.PresignedPostRequest,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'dataUploadRequest2',
        graphql.transformers.OUT.object({
          fields: graphql.transformers.OUT.record(
            graphql.transformers.OUT.tuple([
              graphql.transformers.OUT.nonNull(
                graphql.transformers.OUT.select(
                  'id',
                  graphql.transformers.OUT.validate(
                    transformers.PASS_THROUGH,
                    TypeAsserter.assertIsString,
                  ),
                ),
              ),
              graphql.transformers.OUT.nonNull(
                graphql.transformers.OUT.select(
                  'value',
                  graphql.transformers.OUT.validate(
                    transformers.PASS_THROUGH,
                    TypeAsserter.assertIsString,
                  ),
                ),
              ),
            ] as const),
          ),
          // NOTE: if we do not receive a url, we actually want to throw an
          // error since we can't really proceed with the upload
          url: graphql.transformers.OUT.nonNull(transformers.PASS_THROUGH),
        }),
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.DataUploadRequest2Query,
  ents.core.common.fileManagement.PresignedPostRequest,
  graphql.schema.DataUploadRequest2QueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
